<template>
    <purchase_order_delivery v-if="userInfo.operation_mode == 3" :orderNumber="orderNumber"></purchase_order_delivery>
    <order_delivery v-else :orderNumber="orderNumber"></order_delivery>
</template>

<script>
import order_delivery from './order_wait_delivery_detail.vue'
import purchase_order_delivery from './purchase_order_wait_delivery_detail.vue'
import {mapState} from "vuex";

export default {
    props: {
        orderNumber: String
    },

    computed: {
        ...mapState(['userInfo', 'systemConfig']),
    },

    components: {
        order_delivery,purchase_order_delivery
    }
}
</script>